module.exports = __webpack_public_path__ + "img/plate_photo_5.d654399a.jpg";